import { defineComponent, inject, computed, resolveComponent, openBlock, createBlock, withCtx, createVNode, normalizeProps, guardReactiveProps, mergeProps, createTextVNode, createElementBlock, Fragment, renderList, createSlots, toDisplayString, createCommentVNode } from "vue";
import { u as useDefaults, _ as _export_sfc } from "../_plugin-vue_export-helper-3194dc60.mjs";
import { c as chunk } from "../helpers-674591c1.mjs";
import { u as useDisplay } from "../display-d5494a6d.mjs";
import "../index-fd2245c5.mjs";
import "../_commonjsHelpers-ca272635.mjs";
import "joi";
import "../getCurrentInstance-eec76705.mjs";
const _sfc_main = defineComponent({
  name: "MalarkeyI18nPicker",
  props: {
    /**
     * Specifies whether to hide the badge that displays the current language.
     */
    hideBadge: {
      type: Boolean,
      default: false
    },
    /**
     * The background color of the badge that displays the current language.
     */
    badgeBgColor: {
      type: String,
      default: "primary"
    },
    /**
     * The color of the text of the badge that displays the current language.
     */
    badgeTextColor: {
      type: String,
      default: "white"
    },
    /**
     * Specify the location of the badge that displays the current language.
     */
    badgeLocation: {
      type: String,
      default: "top end"
    },
    /**
     * Specifies the x-axis offset of the badge that displays the current language.
     */
    badgeOffsetX: {
      type: [String, Number],
      default: 7.5
    },
    /**
     * Specifies the y-axis offset of the badge that displays the current language.
     */
    badgeOffsetY: {
      type: [String, Number],
      default: 7.5
    },
    /**
     * Specify the max per column for xs screen sizes
     */
    xsMaxPerColumn: {
      type: Number,
      default: -1
    },
    /**
     * Specify the max per column for sm screen sizes
     */
    smMaxPerColumn: {
      type: Number,
      default: -1
    },
    /**
     * Specify the max per column for md screen sizes
     */
    mdMaxPerColumn: {
      type: Number,
      default: -1
    },
    /**
     * Specify the max per column for lg screen sizes
     */
    lgMaxPerColumn: {
      type: Number,
      default: -1
    },
    /**
     * Specify the max per column for xl screen sizes
     */
    xlMaxPerColumn: {
      type: Number,
      default: -1
    },
    /**
     * Specify the max per column for xxl screen sizes
     */
    xxlMaxPerColumn: {
      type: Number,
      default: -1
    }
  },
  setup(props) {
    const defaultsFromMalarkeyI18nPicker = useDefaults(
      props,
      "MalarkeyI18nPicker"
    );
    const { xs, sm, md, lg, xl, xxl } = useDisplay();
    const lang = inject("lang");
    const show = computed(
      () => "undefined" !== typeof lang && lang.list.value.length > 1
    );
    const badge = computed(
      () => "undefined" !== typeof lang && "undefined" !== typeof lang.language.value && true !== defaultsFromMalarkeyI18nPicker.hideBadge ? lang.language.value.iso2.toUpperCase() : void 0
    );
    const badgeBindings = computed(() => ({
      color: defaultsFromMalarkeyI18nPicker.badgeBgColor,
      textColor: defaultsFromMalarkeyI18nPicker.badgeTextColor,
      location: defaultsFromMalarkeyI18nPicker.badgeLocation,
      content: badge.value,
      offsetX: defaultsFromMalarkeyI18nPicker.badgeOffsetX,
      offsetY: defaultsFromMalarkeyI18nPicker.badgeOffsetY
    }));
    const chunkSize = computed(() => {
      if (xs.value) {
        return props.xsMaxPerColumn;
      } else if (sm.value) {
        return props.smMaxPerColumn;
      } else if (md.value) {
        return props.mdMaxPerColumn;
      } else if (lg.value) {
        return props.lgMaxPerColumn;
      } else if (xl.value) {
        return props.xlMaxPerColumn;
      } else if (xxl.value) {
        return props.xxlMaxPerColumn;
      }
      return -1;
    });
    const chunks = computed(() => {
      if ("undefined" === typeof lang || "undefined" === typeof lang.list.value) {
        return [];
      }
      if (chunkSize.value <= 0) {
        return [
          [...lang.list.value].map((l) => ({
            ...l,
            active: "undefined" !== typeof lang && "undefined" !== typeof lang.language.value && lang.language.value.iso2 === l.iso2
          }))
        ];
      }
      return chunk(
        [...lang.list.value].map((l) => ({
          ...l,
          active: "undefined" !== typeof lang && "undefined" !== typeof lang.language.value && lang.language.value.iso2 === l.iso2
        })),
        chunkSize.value
      );
    });
    const cols = computed(() => Math.ceil(12 / chunks.value.length));
    const onClick = (iso2) => {
      if ("undefined" !== typeof lang) {
        lang.setLocale(iso2);
      }
    };
    return {
      show,
      badgeBindings,
      chunks,
      cols,
      onClick
    };
  }
});
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_v_icon = resolveComponent("v-icon");
  const _component_v_btn = resolveComponent("v-btn");
  const _component_v_badge = resolveComponent("v-badge");
  const _component_v_avatar = resolveComponent("v-avatar");
  const _component_v_list_item = resolveComponent("v-list-item");
  const _component_v_locale_provider = resolveComponent("v-locale-provider");
  const _component_v_col = resolveComponent("v-col");
  const _component_v_row = resolveComponent("v-row");
  const _component_v_card = resolveComponent("v-card");
  const _component_v_menu = resolveComponent("v-menu");
  return _ctx.show ? (openBlock(), createBlock(_component_v_menu, { key: 0 }, {
    activator: withCtx(({ props }) => [
      createVNode(_component_v_badge, normalizeProps(guardReactiveProps(_ctx.badgeBindings)), {
        default: withCtx(() => [
          createVNode(_component_v_btn, mergeProps(props, { icon: "" }), {
            default: withCtx(() => [
              createVNode(_component_v_icon, null, {
                default: withCtx(() => [
                  createTextVNode("mdi-translate")
                ]),
                _: 1
              })
            ]),
            _: 2
          }, 1040)
        ]),
        _: 2
      }, 1040)
    ]),
    default: withCtx(() => [
      createVNode(_component_v_card, {
        "min-width": "280",
        style: { "overflow-x": "hidden", "overflow-y": "hidden" }
      }, {
        default: withCtx(() => [
          createVNode(_component_v_row, null, {
            default: withCtx(() => [
              (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.chunks, (ch, i) => {
                return openBlock(), createBlock(_component_v_col, {
                  cols: _ctx.cols,
                  key: `chunk-${i}`
                }, {
                  default: withCtx(() => [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(ch, (l, j) => {
                      return openBlock(), createBlock(_component_v_locale_provider, {
                        key: `chunk-${i}-lang-${j}`,
                        rtl: l.rtl
                      }, {
                        default: withCtx(() => [
                          createVNode(_component_v_list_item, {
                            title: l.local,
                            subtitle: l.name,
                            active: l.active,
                            onClick: ($event) => _ctx.onClick(l.iso2)
                          }, createSlots({ _: 2 }, [
                            !l.rtl ? {
                              name: "prepend",
                              fn: withCtx(() => [
                                createVNode(_component_v_avatar, {
                                  size: "small",
                                  color: l.active ? _ctx.badgeBindings.color : "grey"
                                }, {
                                  default: withCtx(() => [
                                    createTextVNode(toDisplayString(l.iso2.toUpperCase()), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["color"])
                              ]),
                              key: "0"
                            } : void 0,
                            l.rtl ? {
                              name: "append",
                              fn: withCtx(() => [
                                createVNode(_component_v_avatar, {
                                  size: "small",
                                  color: l.active ? _ctx.badgeBindings.color : "grey"
                                }, {
                                  default: withCtx(() => [
                                    createTextVNode(toDisplayString(l.iso2.toUpperCase()), 1)
                                  ]),
                                  _: 2
                                }, 1032, ["color"])
                              ]),
                              key: "1"
                            } : void 0
                          ]), 1032, ["title", "subtitle", "active", "onClick"])
                        ]),
                        _: 2
                      }, 1032, ["rtl"]);
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["cols"]);
              }), 128))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  })) : createCommentVNode("", true);
}
const MalarkeyI18nPicker = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "MalarkeyI18nPicker.vue"]]);
export {
  MalarkeyI18nPicker as default
};
//# sourceMappingURL=MalarkeyI18nPicker.es.js.map
